import React, { Component } from 'react';
import SidebarReports from 'components/SidebarReports';

class BodyFrame extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSidebar: false,
    };
  }

  toogleSidebar = () => {
    this.setState({
      openSidebar: !this.state.openSidebar,
    });
  };

  render() {
    const { children, location } = this.props;
    const { openSidebar } = this.state;
    return (
      <div className="mk-report-sales full-height">
        <div className="row full-height">
          <SidebarReports
            elementClass="visible-lg visible-md slideMenuWeb"
            location={location}
          />
          <SidebarReports
            elementClass={`visible-xs visible-sm slideMenuMobile ${
              openSidebar ? 'slideMenuMobileSlide' : ''
            }`}
            onToggle={this.toogleSidebar}
            location={location}
          />
          <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 report-right-menu full-height">
            <div className="mk-report-sales-content full-height">
              <div className="mk-burger-box visible-xs visible-sm">
                <div className="mk-burger">
                  <button
                    type="button"
                    className="navbar-toggle collapsed navbar-burger"
                    onClick={this.toogleSidebar}
                    data-toggle="collapse"
                  >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                  </button>
                </div>
              </div>
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BodyFrame;
